import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';

@Component({
	selector: 'spr-section-module-icon',
	templateUrl: './module-icon.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex-none flex w-10 flex-col items-center',
	},
})
export class ModuleIconComponent {
	@Input() public parallel = false;

	@Input() public heightPx = 40;

	@Input() public done = false;
}
